import autoload from "./autoload";
import auth from './mixins/auth';
import cart from './mixins/cart';
import initDom from './mixins/init_dom';
import SearchOtherProducts from "./components/shop/sidebar/filters/SearchOtherProducts";
import ShopMainContent from "./components/shop/ShopMainContent";
import FiltersSidebar from "./components/shop/sidebar/FiltersSidebar";
import Products from './components/shop/products/Products';
import MarketingBanner from './components/shop/MarketingBanner';
import { mapGetters, mapMutations, mapActions } from "vuex";

autoload();

window.app = new Vue({
  el: '#vue-shop',

  mixins: [initDom, auth, cart],

  components: {
    ShopMainContent,
    FiltersSidebar,
    SearchOtherProducts,
    Products,
    MarketingBanner
  },

  computed: {
    ...mapGetters([
      'currentShopPage',
      'selectedCollectionCategory',
      'infiniteId',
      'products',
      'imgLoading',
      'searchText'
    ]),

    // Still needed for other shop pages (i.e. Swatch Sets, Kits, etc.)
    searchTextModel: {
      get() { return this.searchText },
      set(value) { this.setSearchText(value) }
    }
  },

  created() {
    this.getProductsMinMax();
  },

  mounted() {
    this.$on('color-filter-updated', this.resetLoading);

    $(window).on('resize load', this.adjustFilterOffsetsAndSizes);
    $(window).trigger('resize');
  },

  methods: {
    ...mapMutations([
      'setSearchText',
      'setImgLoading'
    ]),
    ...mapActions([
      'searchShop',
      'resetFilters',
      'renderProducts',
      'resetLoading'
    ]),
    onInfinite($state) {
      this.renderProducts()
          .then(response => {
            $state[response]();
          })
          .catch(error => console.error(error))
          .then(this.getProductsMinMax);
    },
    getProductsMinMax() {

      Object.keys(this.products).map(i => {
        this.products[i].minMaxQuantity = this.ProductMinMaxQuantity(this.products[i]);
        this.products[i].isAkzo = this.products[i].categories.filter(cat => cat.code === 'pris_akzonobel').length > 0;
      });

      setTimeout(() => {
        this.setImgLoading(false);
      }, 500);

    },
    adjustFilterOffsetsAndSizes() {
      const windowWidth = $(window).width();
      const fixOnScroll = false;
      const clampHeight = fixOnScroll;
      const maxHeight = 680;
      const maxWidth = 1013;

      let filterOffset = 270;

      if (windowWidth < 1200 && windowWidth > 1069) {
        filterOffset = 350;
      }

      if (windowWidth < 1070) {
        filterOffset = 395;
      }

      const adjustedFilterHeight = 205;

      if (windowWidth >= maxWidth) {
        $('aside .side-box').css('height', 'auto');
        $('aside .side-box').css('overflow-y', 'auto');

        if (clampHeight) {
          if ($(window).height() <= maxHeight) {
            let heightNum = $(window).height() - adjustedFilterHeight;

            $('aside .side-box').css('max-height', heightNum);
          } else {
            $('aside .side-box').css('max-height', '475px');
          }
        } else {
          $('aside .side-box').css('max-height', '');
        }

        $(window).scroll(function() {
          if (fixOnScroll) {
            if ($(window).scrollTop() >= filterOffset && windowWidth > maxWidth) {
              let topNum = $(window).scrollTop() - filterOffset;

              $('aside').css('top', topNum);
            } else {
              $('aside').css('top', '0px');
            }
          } else {
            $('aside').css('top', '0px');
          }
        })
      }
    },
    gtmProductClick(product, productType, index) {
      let vm = this;

      window.dataLayer.push({
        'event': 'productClick',
        'ecommerce': {
          'click': {
            'products': [{
              'name': product.name,
              'id': product.sku,
              'price': product.pricing[0].price_per_base_quantity.amount,
              'brand': "Prismatic",
              'category': productType,
              'position': index
            }]
          }
        }
      });

      // this is for GA4
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: undefined,
          item_list_name: undefined,
          currency: "USD",
          value: undefined,
          items: [{
            item_id: product.sku,
            item_name: product.name,
            affiliation: vm.$root.me.customer_id ? vm.$root.me.customer_id : undefined,
            coupon: undefined,
            currency: "USD",
            discount: undefined,
            index: index,
            item_brand: "Prismatic",
            item_category: product.base_quantity.unit,
            item_list_id: undefined,
            item_list_name: undefined,
            item_variant: undefined,
            location_id: "Shop Collection",
            price: parseFloat(product.pricing[0].price_per_base_quantity.amount),
            quantity: 1
          }]
        }
      });
    }
  }
});

// displays the add-to-cart dropdown
require('./app_events');